import { graphql } from 'gql.tada';
import { useMutation, useQuery } from '@apollo/client';

const AttendanceDayQuery = graphql.persisted(
  "AttendanceDay",
  graphql(`query AttendanceDay($schoolYearId: ID!, $date: ISO8601Date!) {
    schoolYear(id: $schoolYearId) {
      id
      attendanceRolls(date: $date) {
        date
        timeLabel
        attendanceTaken
        attendanceRecordedCount
        expectedStudentCount
        scheduleBlock { id displayTitle }
      }
      schoolClosedDays {
        id
        occursOn
        endsOn
        name
        holidayKey
      }
      attendanceBoardBlockIds
      scheduleBlocks {
        id
        displayTitle
        attendanceEnabled
        term { id name startsOn endsOn }
      }
    }
  }`)
);

const CreateSchoolClosedDayMutation = graphql.persisted(
  "CreateSchoolClosedDay",
  graphql(`mutation CreateSchoolClosedDay($input: CreateSchoolClosedDayInput!) {
    createSchoolClosedDay(input: $input) {
      schoolClosedDay { id occursOn endsOn name }
      userErrors { message path }
    }
  }`)
);

const DeleteSchoolClosedDayMutation = graphql.persisted(
  "DeleteSchoolClosedDay",
  graphql(`mutation DeleteSchoolClosedDay($input: DeleteSchoolClosedDayInput!) {
    deleteSchoolClosedDay(input: $input) {
      success
      userErrors { message path }
    }
  }`)
);

export function useAttendanceDay(schoolYearId?: string, date?: string) {
  return useQuery(AttendanceDayQuery, {
    variables: { schoolYearId: schoolYearId!, date: date! },
    skip: !schoolYearId || !date,
  });
}

export function useCreateSchoolClosedDay() {
  return useMutation(CreateSchoolClosedDayMutation);
}

export function useDeleteSchoolClosedDay() {
  return useMutation(DeleteSchoolClosedDayMutation);
}

const UpdateSchoolClosedDayMutation = graphql.persisted(
  "UpdateSchoolClosedDay",
  graphql(`mutation UpdateSchoolClosedDay($input: UpdateSchoolClosedDayInput!) {
    updateSchoolClosedDay(input: $input) {
      schoolClosedDay { id occursOn endsOn name holidayKey }
      userErrors { message path }
    }
  }`)
);

export function useUpdateSchoolClosedDay() {
  return useMutation(UpdateSchoolClosedDayMutation);
}

const UpdateAttendanceBoardMutation = graphql.persisted(
  "UpdateAttendanceBoard",
  graphql(`mutation UpdateAttendanceBoard($input: UpdateAttendanceBoardInput!) {
    updateAttendanceBoard(input: $input) {
      attendanceBoardBlockIds
      userErrors { message path }
    }
  }`)
);

export function useUpdateAttendanceBoard() {
  return useMutation(UpdateAttendanceBoardMutation);
}
